/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSchedulInfo } from "@/api";
import doctor_head from '@/resources/images/doctorDefault.png';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { MUTATION_APPTREG_ADDREGINFO, GETTER_CLINICOBJ } from '@/store/mutation_types';
import doctorDefault from "../../resources/images/doctorDefault.png";
import Popup from "vux/src/components/popup/index.vue";
import CopyRight from 'CopyRight';
import NoData from 'NoData';
import RegDoctorItem from './CompDocRegItem';
import RegTimeChoose from './CompRegTimeChoose';
export default {
  data: function data() {
    return {
      noDataImg: doctor_head,
      schedulDoctorModel: 0,
      apptPayFlag: 0,
      doctors: [],
      departments: [],
      currentIndex: 0,
      currentSchedule: [],
      isSeeMore: false,
      isHideContent: true,
      isShowSeeMore: false,
      showChoose: false,
      empty: false
    };
  },
  components: {
    Popup: Popup,
    CopyRight: CopyRight,
    RegDoctorItem: RegDoctorItem,
    RegTimeChoose: RegTimeChoose,
    NoData: NoData
  },
  created: function created() {
    //初始化
    this.getClinicInfo();
  },
  mounted: function mounted() {},
  computed: _objectSpread(_objectSpread({}, mapState({
    clinicId: function clinicId(state) {
      return state.clinicId;
    }
  })), mapGetters({
    clinicObj: GETTER_CLINICOBJ
  })),
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setAddRegInfo: MUTATION_APPTREG_ADDREGINFO
  })), {}, {
    onShow: function onShow() {
      console.log('on show');
    },
    onHide: function onHide(type) {
      console.log('on hide', type);
    },
    onChange: function onChange(val) {
      console.log('val change', val);
    },
    emptyFlag: function emptyFlag(data) {
      if (data.length == 0) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * 初始化界面查询排班数据
     */
    getClinicInfo: function getClinicInfo() {
      var _this = this;

      GetSchedulInfo().then(function (data) {
        _this.schedulDoctorModel = data.schedulDoctorModel;
        _this.apptPayFlag = data.apptPayFlag;

        if (data.schedulDoctorModel === '2') {
          //医生排班
          _this.doctors = data.doctors;
          _this.empty = _this.emptyFlag(_this.doctors);
        }
      });
    },
    //选择排班
    schduleChoose: function schduleChoose(index, schduleIndex) {
      console.log(index, schduleIndex);
      /*缓存选择的 诊所 医生 信息*/

      var addRegInfo = {};
      addRegInfo.clinicId = this.clinicId;
      addRegInfo.clinicName = this.clinicObj.scrmClinic.clinicName;
      addRegInfo.schedulDoctorModel = this.schedulDoctorModel;
      var schdule = {}; //医生排班模式

      if (this.schedulDoctorModel === '2') {
        schdule = this.doctors[index].apptDates[schduleIndex];
        addRegInfo.doctorDeptId = this.doctors[index].employeeId;
        addRegInfo.doctorId = this.doctors[index].employeeId;
        addRegInfo.doctorName = this.doctors[index].doctorName;
        addRegInfo.schduleDate = this.doctors[index].apptDates[schduleIndex].scheduleDate; //科室排班模式
      }

      if (schdule.surplusQty <= 0) {
        Public.tips({
          text: "该时段已约满"
        });
        this.isShowSeeMore = false;
        return;
      }

      addRegInfo.apptPayFlag = this.apptPayFlag;
      this.showChoose = true;
      this.setAddRegInfo(addRegInfo); // window.history.replaceState(this.$data, "title");
      // // window.location.href = '../apptReg/regTimeChoose.html';
      // this.$router.push({ name: 'ApptRegRegTimeChoose' })
    },
    goDoctorDetail: function goDoctorDetail(index) {
      var employeeId = this.doctors[index].employeeId;
      this.$router.push({
        name: 'DoctorDetail',
        query: {
          id: employeeId
        }
      });
    }
  })
};